import React from 'react';
import styled from 'styled-components/macro';
import { useOnClickOutside } from 'lib/utils';
import { Modal } from 'lib/components';
import { theme } from 'lib/style';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import { useDeleteCustomerCardMutation } from 'lib/api/billing/useDeleteCustomerCardMutation';

const Header = styled.div`
  display: flex;
`;

const HeaderTitle = styled.div`
  ${theme.fontBold700}
  font-size: ${theme.fontSizes.lg};
  color: ${theme.palette.themeDark};
  font-style: normal;
  font-size: 18px;
  line-height: 24px;
`;

const CloseButtonWrap = styled.div`
  margin-left: auto;
  color: ${theme.palette.white};
  height: 24px;
  width: 24px;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;

const Content = styled.div`
  width: 600px;
  margin-top: 24px;
`;

const Footer = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

type Props = {
  handleModalClose: (shouldRefresh?: boolean) => void;
  id: string;
};

export const RemoveCardModal = (props: Props) => {
  const { mutateAsync: removeCard, isLoading: loading } =
    useDeleteCustomerCardMutation();

  const { handleModalClose, id } = props;

  const { ref } = useOnClickOutside(handleModalClose);

  const escPress = (key: string) => {
    if (key === 'Escape') {
      handleModalClose();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keyup', e => escPress(e.key));

    return () =>
      document.removeEventListener('keyup', e => escPress(e.key), true);
  }, []);

  const deleteCard = async () => {
    await removeCard(id);
    handleModalClose(true);
  };

  return (
    <Modal style={{ position: 'fixed' }}>
      <div ref={ref} style={{ padding: '32px' }}>
        <Header>
          <HeaderTitle>Remove Card?</HeaderTitle>
          <CloseButtonWrap title={'Close'}>
            <IoMdClose
              onClick={() => handleModalClose()}
              size={24}
              color={theme.palette.label}
            />
          </CloseButtonWrap>
        </Header>
        <Content>Are you sure about removing card?</Content>
        <Footer>
          <Button
            variant='secondary'
            text='No, Cancel'
            onClick={async () => {
              handleModalClose();
            }}
            disabled={loading}
          />
          <Button
            variant='destructive'
            text='Yes, Remove'
            onClick={async () => {
              await deleteCard();
            }}
            disabled={loading}
          />
        </Footer>
      </div>
    </Modal>
  );
};
